import { render, staticRenderFns } from "./PortalLayoutConfig.vue?vue&type=template&id=40d2c7a5&scoped=true"
import script from "./PortalLayoutConfig.vue?vue&type=script&lang=js"
export * from "./PortalLayoutConfig.vue?vue&type=script&lang=js"
import style0 from "./PortalLayoutConfig.vue?vue&type=style&index=0&id=40d2c7a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d2c7a5",
  null
  
)

export default component.exports